import { Injectable, OnDestroy } from '@angular/core';
import { ConfiguratorNavigationService } from '@obo-main/services/configurator/configuratorNavigation.service';
import { GridNavigationService } from '@obo-main/services/gridNavigation/gridNavigation.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Injectable()
export class MobileNavigationService implements OnDestroy {
    private isMobileNavigationActive: boolean = false;
    private onDestroy: Subject<void> = new Subject<void>();

    constructor(
        private configuratorNavigationService: ConfiguratorNavigationService,
        private gridNavigationService: GridNavigationService
    ) {
        this.configuratorNavigationService.isActive.pipe(takeUntil(this.onDestroy)).subscribe((active) => {
            this.isMobileNavigationActive = active;
        });
        this.gridNavigationService.isActive.pipe(takeUntil(this.onDestroy)).subscribe((active) => {
            this.isMobileNavigationActive = active;
        });
    }

    public get isActive(): boolean {
        return this.isMobileNavigationActive;
    }

    ngOnDestroy() {
        this.onDestroy.next();
        this.onDestroy.complete();
    }
}
